<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card" style="width: calc(70% - 2em)">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("command palette") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <!-- <div class="title is-5">{{ $t("system shortkeys") }}</div> -->
        <div class="tags">
          <div class="tags has-addons">
            <span class="tag is-medium is-info">Esc</span>
            <span class="tag is-medium is-dark">{{
              $t("close this window")
            }}</span>
          </div>
          <div
            class="tags has-addons"
            v-if="settings_shortkeys && settings_shortkeys.shortkey_home"
          >
            <span class="tag is-medium is-info">{{
              settings_shortkeys.shortkey_home
            }}</span>
            <span class="tag is-medium is-dark">{{ $t("go home") }}</span>
          </div>
          <div
            class="tags has-addons"
            v-if="
              settings_shortkeys && settings_shortkeys.shortkey_show_terminal
            "
          >
            <span class="tag is-medium is-info">{{
              settings_shortkeys.shortkey_show_terminal
            }}</span>
            <span class="tag is-medium is-dark">{{
              $t("command terminal")
            }}</span>
          </div>
          <div
            class="tags has-addons"
            v-if="
              settings_shortkeys &&
              settings_shortkeys.shortkey_show_command_palette
            "
          >
            <span class="tag is-medium is-info">{{
              settings_shortkeys.shortkey_show_command_palette
            }}</span>
            <span class="tag is-medium is-dark">{{
              $t("show command palette")
            }}</span>
          </div>
        </div>

        <!-- <div class="title is-5 mt-5" v-if="shortkeys && shortkeys.length">
          {{ $t("current shortkeys") }}
        </div> -->
        <div class="is-divider"></div>
        <div class="tags">
          <div
            class="tags has-addons"
            v-for="(shortkey, index) in shortkeys"
            :key="index"
          >
            <span class="tag is-medium is-info">{{ shortkey.shortkey }}</span>
            <span class="tag is-medium is-dark">{{
              shortkey.description
            }}</span>
          </div>
        </div>

        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommandPaletteModal",
  data() {
    return {
      is_shown: false,
      meta: {},
      settings_shortkeys: {},
      error: "",
    };
  },
  computed: {},
  props: {
    shortkeys: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    esc_listener(event) {
      if (event.key == "Escape") {
        this.close_modal();
      }
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      window.addEventListener("keyup", v.esc_listener);
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
      window.removeEventListener("keyup", v.esc_listener);
    },
    set_initial_state() {
      this.meta = {};
      this.error = "";
    },
  },
  mounted() {
    let v = this;
    let shortkeys = localStorage.getItem("shortkeys");
    if (shortkeys) {
      let _shortkeys = JSON.parse(shortkeys);
      v.settings_shortkeys = _shortkeys.settings_shortkeys;
    }
  },
};
</script>
<style></style>
